export default "__VITE_ASSET__C0nf0s_v__"